<script setup lang="ts">
import SectionHelp from '@sections/section-help.vue';
import {computed, onBeforeMount, ref} from "vue";
import {useI18n} from "vue-i18n";
import {useSettingsApi} from "@store/api/settingsApi";
// import {useKeyApi} from "@store/api/keyApi";

import {useUserStore} from "@store/user";
import {storeToRefs} from "pinia";
import {TG_PROXY_LINK} from "@/constants";

const {t} = useI18n();

//TODO Сделать разные ссылки для разных языков
// Порядок задаёт раскладку: section-help делит список пополам — первая половина
// это левая колонка, вторая — правая. В левой колонке большая плашка первая,
// в правой — вторая. Итого: [лево-верх (большая), лево-низ, право-верх, право-низ (большая)].
// Ссылки news/support/faq приходят с бэка (/settings/help), UTM-метки не добавляем:
// кабинет и сайт в одном GA4, метки сбили бы источник визита.
const list = ref([
	{
		code: 'faq',
		title: "help.answers",
		url: "",
		icon: {
			name: "comment-2-question",
			viewBox: "0 0 24 24"
		}
	},
	{
		code: 'support',
		title: "help.support",
		url: "",
		icon: {
			name: "comment-2-dots",
			viewBox: "0 0 24 24"
		}
	},
	{
		code: 'news',
		title: "help.news",
		url: "",
		icon: {
			name: "star",
			viewBox: "0 0 24 24"
		}
	},
	{
		code: 'tg_proxy',
		title: "help.tg_proxy",
		url: TG_PROXY_LINK,
		icon: {
			name: "telegram",
			viewBox: "0 0 24 24"
		}
	},
	// {
	//     code: 'instructions',
	// 	title: "help.instructions",
	// 	url: "",
	// 	icon: {
	// 		name: "note-2-text",
	// 		viewBox: "0 0 24 24"
	// 	}
	// },
]);

const settingsApi = useSettingsApi();
// const keyApi = useKeyApi();
const userStore = useUserStore();
const { user } = storeToRefs(userStore);

const fields = computed(() => {
	return {
		icon: '/images/help-icon.svg',
		title: t('help.title'),
		list: list.value
	};
});

const updateItem = (code: string, patch: Record<string, any>) => {
  list.value = list.value.map(item =>
    item.code === code ? { ...item, ...patch } : item
  );
};

onBeforeMount(() => {
  settingsApi.getHelpLinks().then(helpLinks => {
    for (const item of list.value) {
      const match = helpLinks.find(link => link.code === item.code);
      if (match) {
        let url = match.link;
        if (item.code === 'support') {
          url += '?text=' + t('help.support_text_for_link', {"id": user.value.id});
        }
        updateItem(item.code, { url });
      }
    }
  });

  // keyApi.getList().then(keysInfo => {
  //   updateItem('instructions', {
  //     url: keysInfo.sub_link_new || keysInfo.sub_link || ''
  //   });
  // }).catch(() => {});
});
</script>

<template>
	<main class="page">
		<transition
			appear
			name="fade"
			style="--animation-delay: 0.3s"
		>
			<section-help :fields="fields"></section-help>
		</transition>
	</main>
</template>
